import script from "./GlobalLoadingBar.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalLoadingBar.vue?vue&type=script&setup=true&lang=js"

import "./GlobalLoadingBar.vue?vue&type=style&index=0&id=4ef67fd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ef67fd2"]])

export default __exports__